<template>
  <div v-if="loadingStatus" class="body-max-width">
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              height: 120%;
              object-fit: cover;
              overflow: hidden;
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="completeLoading" class="loading-page">
    <img
      src="@/assets/image/Well_Line02_.gif"
      alt="Loading"
      class=""
      style="
        width: 120%;
        margin-left: -20px;
        height: 120%;
        object-fit: cover;
        overflow: hidden;
      "
    />
    <div class="body-max-width description">
      <p class="flex-mid header">{{ $t("waiting") }}</p>
      <p class="flex-mid detail">{{ $t("sendingData") }}</p>
    </div>
  </div>
  <div v-else-if="completeCheckOut">
    <div class="body-max-width">
      <div class="already-get flex-mid">{{ $t("alreadyGetInformation") }}</div>
      <img
        src="@/assets/image/NewDesign/complete.png"
        alt="complete-checkout"
        style="width: 100%"
      />
      <div class="contact-later">
        <p v-html="$t('thank')"></p>
      </div>
    </div>
    <div class="back-to-home-part">
      <button class="back-to-home flex-mid" @click="backToHome">
        {{ $t("gotohome") }}
      </button>
    </div>
  </div>

  <!-- <div
    v-else
    class="body-max-width-no-padding"
    :style="`${shadowScreen ? 'overflow:hidden;min-height:100vh;' : ''}`"
  > -->
  <div v-else class="body-max-width-no-padding">
    <div class="relative">
      <div
        v-if="shadowScreen"
        class="full-screen-shadow-2"
        style="top: 0"
      ></div>
    </div>

    <div class="green-background">
      <div class="body-max-width">
        <Header back="back" :title="$t('checkout')"></Header>
        <div class="body-max-width">
          <div class="select-branch">
            <div class="icon flex-mid">
              <svg
                width="21"
                height="24"
                viewBox="0 0 21 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.212 4.72034C16.9622 5.45969 17.5574 6.33747 17.9634 7.30358C18.3695 8.26967 18.5784 9.30516 18.5784 10.3509C18.5784 11.3966 18.3695 12.4321 17.9634 13.3982C17.5574 14.3643 16.9622 15.2421 16.212 15.9814L10.5 21.6088L4.788 15.9798C4.03789 15.2405 3.44287 14.3626 3.03692 13.3965C2.63096 12.4304 2.42201 11.395 2.42201 10.3493C2.42201 9.3036 2.63096 8.26816 3.03692 7.30206C3.44287 6.33597 4.03789 5.45816 4.788 4.71875C5.53812 3.97933 6.42863 3.3928 7.40868 2.99263C8.38875 2.59246 9.43919 2.3865 10.5 2.3865C11.5608 2.3865 12.6112 2.59246 13.5913 2.99263C14.5714 3.3928 15.4618 3.97933 16.212 4.71875V4.72034ZM17.9243 17.6693C19.3928 16.2219 20.3929 14.3776 20.7982 12.3698C21.2034 10.362 20.9955 8.2809 20.2009 6.38959C19.4061 4.49827 18.0603 2.88174 16.3336 1.74439C14.6068 0.607054 12.5767 0 10.5 0C8.42326 0 6.39316 0.607054 4.66642 1.74439C2.93969 2.88174 1.59388 4.49827 0.799179 6.38959C0.00449056 8.2809 -0.203393 10.362 0.201826 12.3698C0.607045 14.3776 1.60716 16.2219 3.07569 17.6693L8.78607 23.2998C9.0111 23.5218 9.27828 23.6979 9.57238 23.818C9.86646 23.9382 10.1817 24 10.5 24C10.8183 24 11.1336 23.9382 11.4276 23.818C11.7217 23.6979 11.9889 23.5218 12.2139 23.2998L17.9243 17.6693ZM10.5 13.5356C11.3569 13.5356 12.1786 13.2 12.7845 12.6028C13.3904 12.0056 13.7308 11.1955 13.7308 10.3509C13.7308 9.50624 13.3904 8.69621 12.7845 8.09896C12.1786 7.50171 11.3569 7.16619 10.5 7.16619C9.64315 7.16619 8.82139 7.50171 8.2155 8.09896C7.60962 8.69621 7.26923 9.50624 7.26923 10.3509C7.26923 11.1955 7.60962 12.0056 8.2155 12.6028C8.82139 13.2 9.64315 13.5356 10.5 13.5356Z"
                  fill="#337375"
                />
              </svg>
            </div>
            <div>
              <p class="branch">{{ $t("branch") }}</p>
              <div class="branch-box">
                <select
                  class="select-hospital"
                  id="selectHospital"
                  v-model="selectHospital"
                  :placeholder="$t('choosehospital')"
                  @change="getClickPackage()"
                  disabled
                >
                  <option :label="$t('sukhumvit')" value="1"></option>
                  <option :label="$t('srinakarin')" value="2"></option>
                  <option :label="$t('thonburi')" value="4"></option>
                  <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
        <el-option :label="$t('chonburi')" value="5"> </el-option>
        <el-option :label="$t('chinatown')" value="6"> </el-option> -->
                </select>

                <p class="change-branch" @click="changeBranch">
                  {{ $t("changeBranch") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body-max-width">
      <!-- <div>{{ selectPackageData }}</div> -->
      <!-- show main package -->
      <div class="show-health-package">
        <p class="title">{{ $t("healthPackageBooking") }}</p>
        <hr class="seperate-category" />
      </div>
      <div v-for="data in packageData" :key="data.id">
        <div class="package-category">
          <p class="title">{{ data.categoryName }}</p>
        </div>
        <div v-for="item in data.package" :key="item.hospitalPackageId">
          <div class="package-box" v-if="item.available">
            <div :class="`body ${item.showPack ? 'show' : ''}`">
              <div class="show-package-name">
                <div>
                  <input
                    type="checkbox"
                    class="check-box"
                    v-model="item.select"
                    @change="
                      checkShowPackage(item.packageId);
                      duplicateDetail(item.packageId, item.select);
                    "
                  />
                </div>

                <img :src="item.packageInformation.imageUrl" />
                <div class="package-detail">
                  <p class="package-name">
                    {{ item.packageInformation.packageName }}
                  </p>

                  <div v-if="item.isSubset" class="package-detail-duplicate">
                    <p class="item-name">
                      {{ $t("someDetailDup") }}
                    </p>
                  </div>

                  <div class="price">
                    <p class="package-netprice">
                      {{
                        "฿" +
                        numberWithCommasLine(item.packageInformation.netPrice)
                      }}
                    </p>
                    <p class="package-listprice">
                      {{
                        "฿" +
                        numberWithCommasLine(item.packageInformation.fullPrice)
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="body-max-width">
                  <ul v-if="item.showPack" class="package-item">
                    <li
                      class="item-name"
                      v-for="data in item.itemList"
                      :key="data.itemId"
                    >
                      <p v-for="name in data.itemName" :key="name.id">
                        {{ name }}
                      </p>
                    </li>
                  </ul>

                  <div class="package-description">
                    <p
                      class="item-name"
                      v-for="name in item.packageDescription"
                      :key="name.id"
                    >
                      {{ name }}
                    </p>
                  </div>

                  <div
                    v-if="item.isCheckedPastYear"
                    class="package-description"
                  >
                    <p class="item-name">{{ $t("alreadyBuy") }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="footer" v-if="item.itemInformation.length != 0">
              <div
                class="see-detail flex-mid"
                @click="item.showPack = !item.showPack"
              >
                <div v-if="!item.showPack" class="see-detail-box">
                  <p class="text">{{ $t("seeMore") }}</p>
                  <div class="icon">
                    <svg
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.2453 0.290792C10.0579 0.104542 9.8045 0 9.54031 0C9.27612 0 9.02267 0.104542 8.83531 0.290792L5.24531 3.83079L1.70531 0.290792C1.51795 0.104542 1.2645 0 1.00031 0C0.736124 0 0.482672 0.104542 0.29531 0.290792C0.201582 0.383755 0.127187 0.494356 0.0764184 0.616216C0.0256497 0.738075 -0.000488281 0.868781 -0.000488281 1.00079C-0.000488281 1.1328 0.0256497 1.26351 0.0764184 1.38537C0.127187 1.50723 0.201582 1.61783 0.29531 1.71079L4.53531 5.95079C4.62827 6.04452 4.73887 6.11891 4.86073 6.16968C4.98259 6.22045 5.1133 6.24659 5.24531 6.24659C5.37732 6.24659 5.50803 6.22045 5.62989 6.16968C5.75175 6.11891 5.86235 6.04452 5.95531 5.95079L10.2453 1.71079C10.339 1.61783 10.4134 1.50723 10.4642 1.38537C10.515 1.26351 10.5411 1.1328 10.5411 1.00079C10.5411 0.868781 10.515 0.738075 10.4642 0.616216C10.4134 0.494356 10.339 0.383755 10.2453 0.290792Z"
                        fill="#2D7617"
                      />
                    </svg>
                  </div>
                </div>
                <div v-else class="see-detail-box">
                  <p class="text">{{ $t("seeLess") }}</p>
                  <div class="icon">
                    <svg
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.295218 5.9553C0.48258 6.14155 0.736032 6.24609 1.00022 6.24609C1.2644 6.24609 1.51785 6.14155 1.70522 5.9553L5.29522 2.4153L8.83522 5.9553C9.02258 6.14155 9.27603 6.24609 9.54022 6.24609C9.8044 6.24609 10.0579 6.14155 10.2452 5.9553C10.3389 5.86234 10.4133 5.75174 10.4641 5.62988C10.5149 5.50802 10.541 5.37731 10.541 5.2453C10.541 5.11329 10.5149 4.98258 10.4641 4.86072C10.4133 4.73887 10.3389 4.62826 10.2452 4.5353L6.00522 0.295301C5.91225 0.201572 5.80165 0.127179 5.67979 0.0764099C5.55794 0.025641 5.42723 -0.000497311 5.29522 -0.000497323C5.16321 -0.000497334 5.0325 0.025641 4.91064 0.0764098C4.78878 0.127179 4.67818 0.201572 4.58522 0.295301L0.295218 4.5353C0.20149 4.62826 0.127095 4.73886 0.0763265 4.86072C0.0255576 4.98258 -0.000581642 5.11329 -0.000581654 5.2453C-0.000581665 5.37731 0.0255576 5.50802 0.0763264 5.62988C0.127095 5.75174 0.201489 5.86234 0.295218 5.9553Z"
                        fill="#2D7617"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="seperate-category" />
      </div>
    </div>
    <!-- more suggest package -->
    <div class="body-max-width suggest-part">
      <div v-if="associatedNumber > 0">
        <div v-if="associatedList.length > 1" class="more-package">
          {{ $t("morePackage") }} ({{ associatedList.length }}
          {{ $t("package") }})
        </div>
        <div v-else class="more-package">
          {{ $t("morePackage") }} ({{ associatedList.length }}
          {{ $t("manyPackage") }})
        </div>

        <!-- {{ associatedList }} -->
        <div class="more-package-group">
          <swiper
            :slides-per-view="1.5"
            :space-between="10"
            :mousewheel="true"
            :virtualIndex="1"
            :pagination="{
              dynamicBullets: true,
            }"
          >
            <swiper-slide v-for="item in associatedList" :key="item.packageId">
              <div class="more-package-card">
                <div class="package-card-body">
                  <div>
                    <img
                      :src="item.packageInformation.imageUrl"
                      class="card-image"
                    />
                  </div>
                  <div>
                    <div class="card-package-name">
                      {{ item.packageInformation.packageName }}
                    </div>
                    <div class="card-package-price">
                      <div class="net-price">
                        {{
                          "฿" +
                          numberWithCommasLine(item.packageInformation.netPrice)
                        }}
                      </div>
                      <div class="list-price">
                        {{
                          "฿" +
                          numberWithCommasLine(
                            item.packageInformation.fullPrice
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="package-card-footer flex-mid"
                  @click="seeMoreDetail(item)"
                >
                  <div class="content">
                    <img
                      src="@/assets/image/NewDesign/Plus-Icon.svg"
                      class="icon"
                    />
                    <p class="text">{{ $t("selectPackage") }}</p>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="body-max-width" style="margin-top: 2rem; margin-bottom: 2rem">
      <hr style="color: #dcdcdc" />
    </div>
    <!-- appointment detail -->
    <div class="body-max-width appointment-part">
      <p class="appointment-header">{{ $t("appointmentDateil") }}</p>
      <p class="select-appointmenr-header">{{ $t("selectAppointmentDate") }}</p>
      <date-picker
        class="mt-10 mb-10 normal3"
        :class="`${alertSelectDate ? 'error' : ''}`"
        v-model:value="bookingDate"
        style="width: 100%"
        type="date"
        :disabled-date="disabledDate"
        :placeholder="$t('selectAppointmentDate')"
        :lang="lang"
        :formatter="dateFormatter"
      />
      <div v-if="alertSelectDate" style="color: red; font-size: 1.2rem">
        {{ $t("notFillDate") }}
      </div>
      <p class="telephone-number">{{ $t("telephoneNumber") }}</p>
      <el-input
        v-model="phoneNumber"
        class="telephone-input"
        :class="`${alertPhoneNumber ? 'error' : ''}`"
        inputmode="numeric"
        placeholder="089-999-9999"
      ></el-input>
      <div v-if="alertPhoneNumber" style="color: red; font-size: 1.2rem">
        {{ $t("notFillPhoneNumber") }}
      </div>
    </div>

    <!-- <div v-if="totalAmount.total > 0" class="footer-navbar"> -->
    <div class="footer-navbar">
      <p class="total">{{ $t("total") }}</p>
      <div class="price">
        <p class="total-netprice">
          {{ "฿" + numberWithCommasLine(totalAmount.total) }}
          <!-- {{ "฿" + numberWithCommasLine(totalAmount.total) }} -->
        </p>
        <p class="total-listprice">
          <!-- {{ "฿" + numberWithCommasLine(10000) }} -->
          {{ "฿" + numberWithCommasLine(totalAmount.fullTotal) }}
        </p>
      </div>
      <div>
        <button class="checkout-button" @click="checkOut()">
          {{ $t("confirmCheckout") }}
        </button>
      </div>
    </div>

    <div v-if="selectMorePackage" class="more-detail-footer">
      <div class="close" id="close-more-detail-modal" @click="closeModal">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.364835 0.396198C0.598732 0.163084 0.915812 0.0321447 1.2464 0.0321447C1.57699 0.0321447 1.89405 0.163084 2.12796 0.396198L7.48388 5.74064L12.8398 0.396198C12.9541 0.27389 13.0918 0.175797 13.2448 0.107764C13.3978 0.03973 13.563 0.00314873 13.7305 0.000194351C13.898 -0.00276003 14.0643 0.0279955 14.2197 0.0906018C14.3751 0.153208 14.5161 0.246387 14.6345 0.364595C14.7531 0.482804 14.8464 0.623619 14.9091 0.778607C14.9719 0.933613 15.0028 1.09964 14.9998 1.26678C14.9968 1.43393 14.9602 1.59876 14.892 1.75146C14.8238 1.90416 14.7255 2.04159 14.6029 2.15555L9.24701 7.49999L14.6029 12.8444C14.7255 12.9585 14.8238 13.0959 14.892 13.2486C14.9602 13.4013 14.9968 13.5661 14.9998 13.7332C15.0028 13.9004 14.9719 14.0663 14.9091 14.2214C14.8464 14.3764 14.7531 14.5171 14.6345 14.6353C14.5161 14.7537 14.3751 14.8468 14.2197 14.9093C14.0643 14.9719 13.898 15.0028 13.7305 14.9998C13.563 14.9968 13.3978 14.9603 13.2448 14.8922C13.0918 14.8242 12.9541 14.7261 12.8398 14.6038L7.48388 9.25934L2.12796 14.6038C1.89147 14.8237 1.57868 14.9434 1.2555 14.9377C0.932312 14.9319 0.623965 14.8013 0.39539 14.5732C0.166832 14.3452 0.0359114 14.0375 0.0302062 13.715C0.024501 13.3925 0.144477 13.0805 0.364835 12.8444L5.72075 7.49999L0.364835 2.15555C0.13122 1.92215 0 1.60575 0 1.27587C0 0.945994 0.13122 0.62961 0.364835 0.396198Z"
            fill="#AAAAAA"
          />
        </svg>
      </div>
      <div class="more-detail-box">
        <div class="more-detail-header">
          <img :src="showMore.packageInformation.imageUrl" class="header-img" />
          <div class="header-text">
            <p>{{ showMore.packageInformation.packageName }}</p>
            <div
              v-if="
                showMore.packageInformation.netPrice !=
                showMore.packageInformation.fullPrice
              "
              class="price"
            >
              <p class="net-price">
                {{
                  "฿" +
                  numberWithCommasLine(showMore.packageInformation.netPrice)
                }}
              </p>
              <p class="list-price">
                {{
                  "฿" +
                  numberWithCommasLine(showMore.packageInformation.fullPrice)
                }}
              </p>
            </div>
            <div v-else class="price">
              <p class="net-price2">
                {{
                  "฿" +
                  numberWithCommasLine(showMore.packageInformation.netPrice)
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="more-detail-item" v-if="showMore.itemList != null">
          <div
            v-for="item in showMore.itemList"
            :key="item.itemid"
            class="more-detail-itemname"
          >
            <ul>
              <li>
                <p v-for="name in item.itemName" :key="name.id">{{ name }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-for="desc in showMore.packageDescription"
          :key="desc.id"
          class="more-detail-description"
        >
          <p class="more-description">{{ desc }}</p>
        </div>

        <button
          class="add-item-button"
          id="addSuggestItem"
          @click="addPackage(showMore.packageId)"
        >
          <p class="add-item">
            {{ $t("addItem") }}
          </p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
import "swiper/swiper.min.css";
import "swiper/modules/autoplay/autoplay.scss";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import th from "element-plus/dist/locale/th.mjs";
import en from "element-plus/dist/locale/en.mjs";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import DatePicker from "vue-datepicker-next-th";
import "vue-datepicker-next-th/index.css";
import "vue-datepicker-next-th/locale/th";

dayjs.extend(buddhistEra);

var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "Booking",
  components: {
    Header,
    Swiper,
    SwiperSlide,
    DatePicker,
  },
  data() {
    var thLocale = { ...th };
    thLocale["el"]["datepicker"]["year"] = "";
    return {
      searchPagkage: "",
      accessToken: null,
      error: null,
      lang: this.$cookies.get("lang"),
      allPackageList: [],
      packageList: [],
      selectHospital: "1",
      packageId: null,
      packageData: [],
      originalPackageData: [],
      selectPackageData: [],
      clickPackageData: [],
      associatedList: [],
      originalAssociatedList: [],
      associatedPackage: [],
      associatedNumber: 0,
      loadingStatus: true,
      selectMorePackage: false,
      sumPackage: [],
      showMore: [],
      phoneNumber: "",
      bookingDate: "",
      alertSelectDate: false,
      alertPhoneNumber: false,
      packageDetail: [],
      completeCheckOut: false,
      completeLoading: false,
      showCompleteButton: false,
      shadowScreen: false,
      disabledDate: (time) => {
        return time.getTime() < Date.now() + 3 * 24 * 60 * 60 * 1000;
      },
      elementPlusLocale: { th: thLocale, en: en },
      isSetBuddhistYear: false,
      dateFormatter: {
        //[optional] Date to String
        stringify: (date) => {
          if (this.lang == "th") {
            return date ? dayjs(date).format("DD/MM/BBBB") : "";
          } else {
            return date ? dayjs(date).format("DD/MM/YYYY") : "";
          }
        },
        //[optional]  String to Date
        parse: (value) => {
          if (this.lang == "th") {
            return value ? dayjs(value).format("DD/MM/BBBB") : null;
          } else {
            return value ? dayjs(value).format("DD/MM/YYYY") : null;
          }
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          return; // a number
        },
      },
    };
  },
  watch: {
    searchPagkage() {
      this.filterPackage();
    },
    bookingDate() {
      if (this.alertSelectDate) {
        if (this.bookingDate) {
          this.alertSelectDate = false;
        } else {
          this.alertSelectDate = true;
        }
      }
    },
    phoneNumber() {
      if (this.alertPhoneNumber) {
        if (this.phoneNumber && this.phoneNumber.length == 10) {
          this.alertPhoneNumber = false;
        } else {
          this.alertPhoneNumber = true;
        }
      }
    },
    // if (!this.bookingDate) {
    //       this.alertSelectDate = true;
    //     }
    //     if (!this.phoneNumber) {
    //       this.alertPhoneNumber = true;
    //     }
  },
  computed: {
    totalAmount: function () {
      const selectedItems = [];
      let total = 0;
      let fullTotal = 0;
      for (let i in this.packageData) {
        for (let j in this.packageData[i].package) {
          if (
            this.packageData[i].package[j].select &&
            !selectedItems.includes(this.packageData[i].package[j].packageId)
          ) {
            selectedItems.push(this.packageData[i].package[j].packageId);
            total += this.packageData[i].package[j].select
              ? this.packageData[i].package[j].netPrice
              : 0;
            fullTotal += this.packageData[i].package[j].select
              ? this.packageData[i].package[j].fullPrice
              : 0;
          }
        }
      }
      return {
        fullTotal: fullTotal,
        total: total,
      };
    },
    SelectPackage: function () {
      const selectedItems = [];
      const selectedItemsData = [];

      for (let i in this.packageData) {
        for (let item of this.packageData[i].package) {
          if (item.select) {
            // if (!(selectedItems.includes(item.packageId))) {
            selectedItems.push(item.packageId);
            selectedItemsData.push(item);
            // }
          }
        }
      }

      for (let i in this.selectPackageData) {
        if (this.selectPackageData[i].select) {
          if (!selectedItems.includes(this.selectPackageData[i].packageId)) {
            selectedItems.push(this.selectPackageData[i].packageId);
            selectedItemsData.push(this.selectPackageData[i]);
          }
        }
      }
      for (let i in this.prerequisiteList) {
        if (this.prerequisiteList[i].select) {
          if (!selectedItems.includes(this.prerequisiteList[i].packageId)) {
            selectedItems.push(this.prerequisiteList[i].packageId);
            selectedItemsData.push(this.prerequisiteList[i]);
          }
        }
      }
      return selectedItemsData;
    },
  },
  mounted() {
    scrollTo(0, 0);
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.selectHospital = this.$store.state.selectedHospital;
    this.sumPackage = this.$store.state.selectedPackageList;
    this.getData();
    this.getClickPackage();
  },
  methods: {
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    closeModal() {
      this.selectMorePackage = false;
      this.shadowScreen = false;
    },
    checkShowPackage(packageId) {
      let index = this.originalPackageData.findIndex(
        (item) => item.packageId === packageId
      );
      if (
        !this.originalPackageData[index].select &&
        this.originalPackageData[index].Remark == "associatedPackage"
      ) {
        this.originalPackageData.forEach((item) => {
          if (item.packageId == this.originalPackageData[index].packageId) {
            item.showAssociated = true;
            item.select = true;
            item.available = true;
            if (!this.associatedList.includes(item)) {
              this.associatedList.push(item);
            }
          }
        });
        this.originalPackageData[index].available = false;
        this.originalPackageData.splice(index, 1);
      }
      this.groupData();
    },
    changeBranch() {
      this.$router.push({
        path: "/show-all-package",
      });
    },
    addPackage(packageId) {
      this.associatedList.forEach((item) => {
        if (item.packageId == packageId) {
          item.select = true;
          item.available = true;
          if (!this.originalPackageData.includes(item)) {
            this.originalPackageData.push(item);
          }
        }
      });
      this.associatedList.forEach((item) => {
        if (item.packageId == packageId) {
          item.showAssociated = false;
        }
      });
      let amount = 0;
      for (let i = 0; i < this.associatedList.length; i++) {
        if (!this.associatedList[i].showAssociated) {
          this.associatedList.splice(i, 1);
        } else {
          amount++;
        }
      }
      this.associatedNumber = amount;

      // for (let i = 0; i < this.packageData.length; i++) {
      //   if (this.packageData[i].packageId == packageId) {
      //     this.packageData[i].select = true;
      //     this.packageData[i].available = true;
      //   }
      // }
      // for (let i = 0; i < this.associatedPackage.length; i++) {
      //   if (this.associatedPackage[i].packageId == packageId) {
      //     this.associatedPackage[i].available = true;
      //   }
      // }
      this.groupData();
      this.selectMorePackage = false;
      this.shadowScreen = false;
    },
    groupData() {
      let groupData = this.groupBy(this.originalPackageData, "categoryName");
      let mainPackageData2 = [];
      for (let key in groupData) {
        mainPackageData2.push({
          categoryName: key,
          package: groupData[key],
        });
      }
      this.packageData = mainPackageData2;
      this.duplicateDetail();
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getClickPackage() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital-package/get-package-by-ids",
          {
            hospitalPackageDetailBean: {
              hospitalId: this.selectHospital,
              packageIds: this.sumPackage,
            },
          },
          {
            headers: {
              Authorization: "Bearer " + this.accessToken,
              "Accept-Language": this.lang,
            },
          }
        )
        .then((res) => {
          console.log("get package by id", res.data);
          let hospitalPackages = [];
          let mainPackage = [];
          let associatedPackage = [];
          let mainPackageData = [];
          let associatedPackageData = [];
          let mainData = [];
          let associatedData = [];
          let data = res.data;
          data.forEach((element) => {
            hospitalPackages.push(element.hospitalPackageBean);
          });
          hospitalPackages.forEach((e) => {
            mainPackage.push(e.mainPackage);
            associatedPackage.push(e.associatedPackages);
          });
          associatedPackage = associatedPackage.flat();
          associatedPackage = associatedPackage.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.packageId === item.packageId)
          );
          for (let i = 0; i < mainPackage.length; i++) {
            for (let j = 0; j < associatedPackage.length; j++) {
              if (mainPackage[i].packageId == associatedPackage[j].packageId) {
                associatedPackage.splice(j, 1);
              }
            }
          }
          mainPackage.forEach((e) => {
            mainPackageData.push({
              ...e,
              select: true,
              showPack: false,
              available: true,
              isSubset: false,
              imageUrl: e.packageInformation.imageUrl,
              riskInformation: e.riskInformation,
              intervalDays: e.packageInformation.intervalDays,
              specialtyCode: e.packageInformation.specialtyCode,
              practitionerId: e.packageInformation.practitionerId,
              categoryName:
                e.packageInformation.categoryInformation.categoryName,
              fullPrice: e.packageInformation.fullPrice,
              netPrice: e.packageInformation.netPrice,
              Remark: "mainPackage",
              packageId: e.packageId,
              packageName: e.packageInformation.packageName,
              itemList: e.itemInformation,
              isCheckedPastYear: e.isCheckedPastYear,
              packageInformation: {
                ...e.packageInformation,
              },
              packageDescription: e.packageInformation.packageDescription
                ? e.packageInformation.packageDescription.split("\n")
                : e.packageInformation.packageDescription,
            });
          });
          associatedPackage.forEach((e) => {
            associatedPackageData.push({
              ...e,
              select: false,
              showPack: false,
              showAssociated: true,
              available: false,
              isSubset: false,
              imageUrl: e.packageInformation.imageUrl,
              riskInformation: e.riskInformation,
              intervalDays: e.packageInformation.intervalDays,
              specialtyCode: e.packageInformation.specialtyCode,
              practitionerId: e.packageInformation.practitionerId,
              categoryName:
                e.packageInformation.categoryInformation.categoryName,
              fullPrice: e.packageInformation.fullPrice,
              netPrice: e.packageInformation.netPrice,
              Remark: "associatedPackage",
              packageId: e.packageId,
              packageName: e.packageInformation.packageName,
              itemList: e.itemInformation,
              isCheckedPastYear: e.isCheckedPastYear,
              packageInformation: {
                ...e.packageInformation,
              },
              packageDescription:
                e.packageInformation.packageDescription.split("\n"),
            });
          });

          for (let i = 0; i < mainPackageData.length; i++) {
            for (let j = 0; j < mainPackageData[i].itemList.length; j++) {
              mainPackageData[i].itemList[j].itemName =
                mainPackageData[i].itemList[j].name.split("\n");
            }
          }
          for (let i = 0; i < associatedPackageData.length; i++) {
            for (let j = 0; j < associatedPackageData[i].itemList.length; j++) {
              associatedPackageData[i].itemList[j].itemName =
                associatedPackageData[i].itemList[j].name.split("\n");
            }
          }

          associatedData = associatedPackageData;
          mainData = mainPackageData;
          this.originalPackageData = mainData;

          this.duplicateDetail();
          this.groupData();
          this.associatedList = associatedData;
          this.originalAssociatedList = associatedData;
          this.associatedNumber = associatedPackageData.length;
          this.loadingStatus = false;
        });
    },

    duplicateDetail() {
      let subsetList = [];
      this.packageData.forEach((item) => {
        item.package.forEach((item2) => {
          if (item2.select) {
            item2.isSubset = false;
            item2.subsetPackageIds.forEach((item3) => {
              if (!subsetList.includes(item3)) {
                subsetList.push(item3);
              }
            });
          }
        });
      });
      for (let i = 0; i < subsetList.length; i++) {
        this.packageData.forEach((item) => {
          item.package.forEach((item2) => {
            item2.isSubset = false;
            if (item2.packageId == subsetList[i]) {
              item2.isSubset = true;
            }
          });
        });
      }
    },
    seeMoreDetail(data) {
      this.selectMorePackage = true;
      this.shadowScreen = true;
      this.showMore = data;
    },
    checkOut(redirect) {
      if (!this.bookingDate || !this.phoneNumber) {
        if (!this.bookingDate) {
          this.alertSelectDate = true;
        }
        if (!this.phoneNumber) {
          this.alertPhoneNumber = true;
        }
      } else {
        this.completeLoading = true;
        this.alertSelectDate = false;
        this.alertPhoneNumber = false;
        let items = [];
        for (let item of this.SelectPackage) {
          items.push({
            hospitalPackageId: item.hospitalPackageId,
            quantity: 1,
            purchasePrice: item.packageInformation.netPrice,
          });
        }
        let req = {
          purchasePackageCartRequestBean: {
            purchaseType: 1,
            purchaseStatus: 2,
            coin: 0,
            discountCode: null,
            phoneNumber: this.phoneNumber,
            totalPurchasePrice: this.totalAmount.total,
            primaryAppointmentDate:
              this.bookingDate.getFullYear() +
              "-" +
              ("0" + (this.bookingDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + this.bookingDate.getDate()).slice(-2) +
              " 00:00:00",
            secondaryAppointmentDate: null,
            purchasePackages: items,
          },
        };

        axios
          .post(
            process.env.VUE_APP_TOTALHEALTHAPI_URL +
              "/total-health-solution/purchase-cart/insert-purchase-package",
            req,
            {
              headers: {
                // 'x-api-key': HEALTH_DIARY_API_KEY,
                Authorization: "Bearer " + this.accessToken,
                accept: "application/json; charset=UTF-8",
                "Accept-Language": this.lang,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            let orderNumber = res.data.orderNumber;
            this.Loading = false;
            this.$gtag.config({
              user_id: this.username,
            });
            this.$gtag.event("click_checkout_booking_button", {
              event_category: "Booking_page",
              event_label: "click checkout Booking button",
            });
            this.completeLoading = false;
            this.completeCheckOut = true;
          })
          .catch((error) => {
            this.Loading = false;
            if (error.response == null) {
              this.errmsg = error;
            } else if (error.response.status == 403) {
              this.getNewToken();
            } else {
              if (error.response.data.error) {
                this.errmsg = error.response.data.error;
              } else {
                this.errmsg = error;
              }
            }
            window.setTimeout(function () {
              window.$("#loadingModal").modal("hide");
              window.$("#errorModal").modal("show");
            }, 500);
          });
      }
    },
    backToHome() {
      window.location.href = "/home";
    },
    getNewToken() {
      var refreshToken = this.$cookies.get("refresh_token");
      var token = new AmazonCognitoIdentity.CognitoRefreshToken({
        RefreshToken: refreshToken,
      });

      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );
      const cognitoUser = this.$store.state.userPool.getCurrentUser();
      cognitoUser.refreshSession(token, (err, session) => {
        this.accessToken = session.getIdToken().getJwtToken();
        this.$cookies.set("access_token", this.accessToken);
        this.$cookies.set(
          "refresh_token",
          session.getRefreshToken().getToken()
        );
        window.location.reload();
      });
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          this.phoneNumber = res.data.customer.phoneNumber;
        })
        .catch((error) => {
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            // this.loadingStatus = false;
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
  },
});
</script>
<style lang="scss" scoped>
.green-background {
  background: #ecf5ca;

  // padding-bottom: 5rem;
  .select-branch {
    display: grid;
    grid-template-columns: 10% auto;
    gap: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding-bottom: 2rem;

    .icon {
    }

    .branch {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 0rem;
    }

    .branch-box {
      display: grid;
      grid-template-columns: 60% 40%;
      gap: 1rem;

      .select-hospital {
        font-size: 1.8rem;
        font-weight: 500;
        color: #337375;
        height: 7.1rem;
        width: 100%;
        // width: 70%;
        background: transparent;
        -webkit-appearance: none;
        border: 0px;
        outline: 0px;
        border-radius: 4.1rem;
        margin-top: 0rem;

        @media only screen and (max-width: 500px) {
          font-size: 1.6rem;
        }

        @media only screen and (max-width: 400px) {
          font-size: 1.4rem;
        }
      }

      .change-branch {
        line-height: 4rem;
        margin-top: 1.5rem;
        font-size: 1.4rem;
        color: #2d7617;
        text-decoration: underline;

        @media only screen and (max-width: 500px) {
          font-size: 1.2rem;
        }
      }
    }
  }
}

.search-bar {
  margin-top: -5rem;

  .search-box {
    height: 5rem;
    width: 100%;
    margin-top: -2.5rem;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    border: 2px solid #cceab5;
    border-radius: 9rem;
    padding: 1rem;
  }
}

.filter-group {
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 49% 45%;

  .filter-category {
    padding: 1rem;
    height: 48px;
    border-radius: 50px;
    border: #b2c1b2 1px solid;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  .filter-type {
    padding: 1rem;
    height: 48px;
    border-radius: 50px;
    border: #b2c1b2 1px solid;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }
}

.package-card-container {
  display: block;
  padding-bottom: 3rem;

  .package-card-show {
    margin-top: 1rem;
    border-radius: 15px;
    -webkit-appearance: none;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    // border: 1px solid #fff;
    // border:solid 1rem #000;

    -webkit-box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);

    .content {
      width: 100%;
      object-fit: cover;

      .image {
        width: 100%;
        height: 14rem;
        object-fit: cover;
      }

      .text {
        padding: 1rem;

        .package-name {
          color: #474747;
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;
          letter-spacing: 0em;
          text-align: left;

          @media only screen and (max-width: 500px) {
            font-size: 1.4rem;
          }
        }

        .box-below {
          display: inline-flex;
          justify-content: space-between;
          width: 100%;

          .package-price {
            width: 100%;
            display: inline-flex;
            // justify-content: space-between;

            .net-price {
              color: #ff3636;
              font-size: 18px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
            }

            .net-price-2 {
              color: #000000;
              font-size: 18px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
            }

            .list-price {
              color: #777e90;
              font-size: 12px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
              text-decoration: line-through;
              margin-left: 1rem;
            }
          }

          .booking-button {
            border: none;
            background: #d2e97a;
            color: #ffffff;
            width: 10rem;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0em;
            text-align: center;
            width: 102px;
            height: 46px;
            border-radius: 30px;
          }
        }
      }

      // -webkit-appearance: none;
      // -webkit-box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
    }
  }

  @media only screen and (min-width: 714px) {
    grid-template-columns: calc(33% - 0.8rem) calc(33% - 0.8rem);
  }
}

.package-category {
  margin-bottom: 2rem;

  .title {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }
}

.show-health-package {
  .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    @media only screen and (max-width: 400px) {
      font-size: 16px;
    }
  }
}

.package-box {
  border: #cceab5 1px solid;
  position: relative;
  width: 100%;
  // max-height: 18.3rem;
  border-radius: 27px;
  margin: auto;
  margin-bottom: 2rem;
  // overflow: hidden;

  .body {
    // max-height: 13.3rem;
    overflow: hidden;

    .show-package-name {
      display: grid;
      grid-template-columns: 10% 40% auto;
      // margin: 0 0 2.6rem;
      margin: 1rem;
      padding: 1rem 1rem 1rem 1rem;

      .check-box {
        width: 24px;
        height: 24px;
        border-radius: 8px;
        border: #43b422 1px solid;
        accent-color: #4ea834;
        color: #ffffff;
      }

      .check-box:checked ~ .checkmark {
        background-color: #4ea834;
      }

      img {
        width: 12rem;
        height: 10rem;
        margin: 0rem auto;
        object-fit: cover;
        border-radius: 15px;
      }

      .package-detail {
        margin-left: 1rem;

        .package-name {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;

          @media only screen and (max-width: 500px) {
            font-size: 1.4rem;
          }
        }

        .price {
          display: grid;
          grid-template-columns: auto auto;
          gap: 1rem;

          .package-netprice {
            color: #ff3636;
            font-size: 18px;
            font-weight: 500;
            line-height: 33px;
            letter-spacing: 0em;
            text-align: left;
          }

          .package-listprice {
            color: #777e90;
            font-size: 12px;
            font-weight: 500;
            line-height: 33px;
            letter-spacing: 0em;
            text-align: left;
            text-decoration: line-through;
          }
        }
      }
    }

    .package-item {
      .item-name {
        color: #545454;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
      }
    }

    .package-detail-duplicate {
      .item-name {
        color: #f57d0e;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    .package-description {
      .item-name {
        color: #c31212;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
      }
    }
  }

  .body.show {
    overflow: auto;
    height: auto;
  }

  .see-detail {
    // display: flex;
    // position: relative;
    bottom: 0;
    width: 100%;
    background: #ecf5ca;
    margin: auto;
    // padding: 2rem ;
    height: 35px;
    text-align: center;
    border-radius: 0rem 0rem 27px 27px;

    .see-detail-box {
      display: flex;

      .text {
        text-align: center;
        color: #2d7617;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        margin: auto;
        text-decoration: underline;
      }

      .icon {
        line-height: 18px;
        margin-left: 1rem;
      }
    }
  }
}

.suggest-part {
  .more-package {
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;

    @media only screen and (max-width: 400px) {
      font-size: 16px;
    }
  }

  .more-package-group {
    margin-top: 2rem;

    .more-package-card {
      border: 1px solid #cceab5;
      width: 100%;
      // height: 15rem;
      border-radius: 20px;
      // padding: 1rem;
      min-height: 13rem;

      .package-card-body {
        display: grid;
        grid-template-columns: 40% 60%;
        gap: 1rem;
        padding: 1rem;

        .card-image {
          width: 8rem;
          height: 7.5rem;
          object-fit: cover;
          border-radius: 12px;
        }

        .card-package-name {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          min-height: 3rem;
          text-align: left;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;

          @media only screen and (max-width: 500px) {
            font-size: 14px;
          }
        }

        .card-package-price {
          display: inline-flex;
          width: 90%;
          justify-content: space-between;
          margin-top: 1rem;
          margin-bottom: 1rem;

          .net-price-2 {
            color: #000000;
            font-size: 16px;
            font-weight: 500;
            line-height: 29px;
            letter-spacing: 0em;
            text-align: left;
          }

          .net-price {
            color: #ff3636;
            font-size: 16px;
            font-weight: 500;
            line-height: 29px;
            letter-spacing: 0em;
            text-align: left;
          }

          .list-price {
            color: #c0c0c0;
            font-size: 12px;
            font-weight: 500;
            line-height: 29px;
            letter-spacing: 0em;
            text-align: left;
            text-decoration: line-through;
          }
        }
      }

      .package-card-footer {
        bottom: 0;
        position: absolute;
        width: 100%;
        border: 1px solid #cceab5;
        border-top-style: solid;
        border-right-style: none;
        border-bottom-style: none;
        border-left-style: none;
        border-radius: 0 0 19px 19px;
        margin: auto;

        .content {
          display: flex;
          // width: 60%;

          .icon {
            margin: auto;
            width: 1.6rem;
            margin-right: 1rem;
          }

          .text {
            color: #2b782e;
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;
            // text-align: center;
            margin: auto;
          }
        }
      }
    }
  }

  .swiper-pagination-progressbar-active {
    background: #ffffff;
  }

  .swiper-pagination-progressbar {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    margin-top: 3rem;
  }
}

.appointment-part {
  padding-bottom: 10rem;

  .appointment-header {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;

    @media only screen and (max-width: 400px) {
      font-size: 16px;
    }
  }

  .select-appointmenr-header {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0em;

    @media only screen and (max-width: 400px) {
      font-size: 16px;
    }
  }

  .telephone-number {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0em;

    @media only screen and (max-width: 400px) {
      font-size: 16px;
    }
  }
}

.footer-navbar {
  position: fixed;
  bottom: 0;
  background: #ecf5ca;
  width: 100%;
  height: 8rem;
  z-index: 3;
  padding: 1rem;
  border-radius: 25px 25px 0 0;
  display: grid;
  grid-template-columns: 20% 30% 40%;
  gap: 1rem;
  filter: drop-shadow(5px 5px 5px rgba(148, 148, 148, 0.25));

  .total {
    color: #000000;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    margin: auto;
    margin-top: 1rem;
  }

  .price {
    margin-top: 1rem;

    .total-netprice {
      font-size: 20px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      color: #000000;
    }

    .total-listprice {
      color: #9a9a9a;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0em;
      text-align: left;
      text-decoration: line-through;
    }
  }

  .checkout-button {
    margin-top: 1rem;
    height: 3.2rem;
    // width: 14.3rem;
    width: 100%;
    border: none;
    border-radius: 30px;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    background: #ffffff;
    color: #000000;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
  }

  .checkout-button:focus {
    outline: none;
  }
}

.more-detail-footer {
  bottom: 0;
  position: fixed;
  // height: 50vh;
  width: 100%;
  z-index: 99;
  background: #ffffff;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  padding: 1rem;
  padding-bottom: 2rem;

  .more-detail-box {
    margin: auto;
    margin-top: 2rem;
    width: 90%;

    .close {
      width: 2rem;
      height: 2rem;
    }

    .more-detail-header {
      display: grid;
      grid-template-columns: 30% 70%;
      gap: 1rem;

      .header-img {
        margin: auto;
        width: 6rem;
        height: 6rem;
        object-fit: cover;
        border-radius: 15px;
      }

      .header-text {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;

        .price {
          display: inline-flex;

          .net-price {
            color: #c31212;
            font-size: 1.6rem;
          }

          .net-price2 {
            color: #545454;
            font-size: 1.6rem;
          }

          .list-price {
            margin-left: 2rem;
            text-decoration: line-through;
            color: #545454;
            font-size: 1.2rem;
          }
        }
      }
    }

    .more-detail-item {
      max-height: 20rem;
      overflow: scroll;

      .more-detail-itemname {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        color: #545454;
      }
    }

    .more-detail-description {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0em;
      // color: #545454;
      color: #c31212;

      .more-description {
        color: #c31212;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0em;
        margin-top: 1rem;
      }
    }

    .add-item-button {
      width: 100%;
      height: 40px;
      margin: auto;
      border-radius: 30px;
      background: #d2e97a;
      outline: none;
      border: none;

      .add-item {
        font-size: 16px;
        font-weight: 500;
        line-height: 40px;
        letter-spacing: 0em;
        text-align: center;
        color: #000000;
      }
    }
  }
}

hr.seperate-category {
  border-top: 1px solid #dbe7d4;
}

.already-get {
  margin: 5rem;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 33px;
  text-align: center;
}

.contact-later {
  color: #1f2022;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0.20000000298023224px;
  text-align: center;
}

.within-48-hours {
  color: #429928;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0.20000000298023224px;
  text-align: center;
}

.back-to-home-part {
  width: 100%;
  position: fixed;
  bottom: 0;

  .back-to-home {
    margin: auto;
    margin-top: 5rem;
    margin-bottom: 2rem;
    background: #d2e97a;
    color: #000000;
    width: 80%;
    height: 4rem;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
  }

  .back-to-home:focus {
    outline: none;
  }
}

.loading-page {
  .description {
    .header {
      color: #000000;
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0em;
    }

    .detail {
      color: #1f2022;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.20000000298023224px;
      text-align: center;
    }
  }
}

// .swiper-pagination-progressbar {
//   background-color: rgba(255, 255, 255, 0.3);
//   border-radius: 5px;
//   bottom: 0rem;
// }
</style>
